import {environment} from '../../../../environments/environment';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {CustomsValidators} from '../../validators/custom.validators';
import {throwError} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PolicyListService {
  urlPolicyListPage: string;
  urlPolicyObservation: string;

  constructor(private http: HttpClient) {
    this.urlPolicyListPage = `${environment.bffBaseUrl}/pages/policy-list`;
    this.urlPolicyObservation = `${environment.bffBaseUrl}/pages/policy-observations/`;
  }

  getPolicyList(page, limit, urlFilter) {
    const urlBuilder = this.urlPolicyListPage + '?page=' + page + '&limit=' + limit + urlFilter;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  getPolicyDetails(id) {
    const urlBuilder = this.urlPolicyListPage + '/' + id;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  getObservacion(id: any) {
    const urlBuilder = this.urlPolicyObservation + id;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }
}
